<template>
  <div>
    <Navbar />
      <div class="owner-body">
        <div class="sidebar">
            <Sidebar />
        </div>
        <div class="page">
          <card-component>
              <div class="heading">
                <h3>Expansion</h3>
              </div>
              <section>
                <b-collapse
                    class="card"
                    animation="slide"
                    v-for="(collapse, index) of collapses"
                    :key="index"
                    :open="isOpen == index"
                    @open="isOpen = index">
                    <div
                        slot="trigger"
                        slot-scope="props"
                        class="card-header"
                        role="button">
                        <p class="card-header-title">
                            {{ collapse.title }}
                        </p>
                        <a class="card-header-icon">
                            <b-icon
                                :icon="props.open ? 'menu-down' : 'menu-up'">
                            </b-icon>
                        </a>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            {{ collapse.text }}
                        </div>
                    </div>
                </b-collapse>
            </section>
          </card-component>
          <!--  -->
          <card-component class="card-2">
              <div class="heading">
                <h3>Expansion</h3>
              </div>
              <section>
                <b-collapse
                    class="card"
                    animation="slide"
                    v-for="(collapse, index) of collapses"
                    :key="index"
                    :open="isOpen == index"
                    @open="isOpen = index">
                    <div
                        slot="trigger"
                        slot-scope="props"
                        class="card-header"
                        role="button">
                        <p class="card-header-title">
                            {{ collapse.title }}
                        </p>
                        <a class="card-header-icon">
                            <b-icon
                                :icon="props.open ? 'menu-down' : 'menu-up'">
                            </b-icon>
                        </a>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            {{ collapse.text }}
                        </div>
                    </div>
                </b-collapse>
            </section>
          </card-component>
        </div>
      </div>
  </div>
</template>

<script>
import Navbar from '@/components/NavBar.vue';
import Sidebar from '@/components/OwnerSidebar.vue';
import CardComponent from '@/components/CardComponent.vue';

export default {
  name: 'Logs',
  components: {
    Navbar,
    Sidebar,
    CardComponent
  },
  data() {
    return {
      isOpen: 0,
      collapses: [
        {
          title: 'Title 1',
          text: 'Text 1'
        },
        {
          title: 'Title 2',
          text: 'Text 2'
        },
        {
          title: 'Title 3',
          text: 'Text 3'
        }
      ]
    };
  }
};
</script>

<style scoped>
.heading {
  background: #FBFBFB;
  padding: 20px;
}
.heading h3 {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #736F6F;
  margin-bottom: 27px;
  text-transform: capitalize;
}
.card-2 {
  margin-top: 50px;
}
</style>
